import {
    CommandBarButton,
    IButtonStyles,
    INavLinkGroup,
    INavStyles,
    IRenderFunction,
    IRenderGroupHeaderProps,
    Nav,
    useTheme
} from '@fluentui/react';
import classNames from 'classnames/bind';
import React, { useContext, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    AppPage,
    HamburgerMenuStyleGroups
} from '../../Models/Constants/Enums';
import { IHamburgerMenuProps } from '../../Models/Constants/Interfaces';
import { AppContext } from '../../Pages/App/App';
import styles from './HamburgerMenu.module.scss';
const cx = classNames.bind(styles);

const HamburgerMenu: React.FC<IHamburgerMenuProps> = ({ isExpanded }) => {
    const { activePage, setActivePage } = useContext(AppContext);
    const [isNavExpanded, setIsNavExpanded] = useState(isExpanded);
    const navigate = useNavigate();
    const themeObj = useTheme();

    const navStyles: Record<
        HamburgerMenuStyleGroups,
        Partial<INavStyles>
    > = useMemo(
        () => ({
            expanded: {
                root: {
                    width: 208
                }
            },
            collapsed: {
                root: {
                    width: 48
                }
            }
        }),
        []
    );

    const navLinkGroups: INavLinkGroup[] = useMemo(
        () => [
            {
                name: 'Pages',
                links: [
                    {
                        name: 'Graph',
                        url: '/',
                        icon: 'GitGraph',
                        key: 'graphs-page',
                        target: '_blank'
                    },
                    {
                        name: '3D Scenes',
                        url: '/3DScenes',
                        icon: 'ProductVariant',
                        key: 'scene-3D',
                        onClick(event, _element) {
                            event?.preventDefault();
                            setActivePage(AppPage.Scene3D);
                            navigate('/3DScenes');
                        }
                    },
                    {
                        name: 'Tools',
                        url: '/tools',
                        icon: 'Toolbox',
                        key: 'tools',
                        onClick(event, _element) {
                            event?.preventDefault();
                            setActivePage(AppPage.Tools);
                            navigate('/tools');
                        }
                    }
                ]
            }
        ],
        [navigate, setActivePage]
    );

    const hamburgerButtonStyle: Partial<IButtonStyles> = {
        root: { width: '100%', height: 44, display: 'flex' }
    };

    function _onRenderGroupHeader(_group: INavLinkGroup): JSX.Element {
        return (
            <CommandBarButton
                styles={hamburgerButtonStyle}
                iconProps={{ iconName: 'GlobalNavButton' }}
                onClick={() => setIsNavExpanded(!isNavExpanded)}
            />
        );
    }

    return (
        <Nav
            ariaLabel="Navigation menu"
            groups={navLinkGroups}
            styles={{
                root: {
                    ...(themeObj.components?.Nav.styles as any).root,
                    ...(isNavExpanded
                        ? (navStyles.expanded.root as any)
                        : (navStyles.collapsed.root as any))
                }
            }}
            selectedKey={
                ['data-pusher', 'tools'].includes(activePage)
                    ? 'tools'
                    : activePage
            }
            onRenderGroupHeader={
                _onRenderGroupHeader as IRenderFunction<IRenderGroupHeaderProps>
            }
            className={cx('leftNav')}
        />
    );
};

export default HamburgerMenu;
